import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import PaymentSettingsPageUI from './PaymentSettingsPageUI.js'

class PaymentSettingsPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      paymentMethodList: null,
      stripeApiKey: null,
      messageList: null,
      errorList: [],
    }
  }

  render() {
    return (
      <PaymentSettingsPageUI
        context={this.props.context}
        paymentMethodList={this.state.paymentMethodList}
        stripeApiKey={this.state.stripeApiKey}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        //
        onPaymentSettingsChange={this.onPaymentSettingsChange}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getPaymentMethods(context)
    this.getStripeApiKey(context)
    this.getMessages(context)
  }

  getPaymentMethods(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/paymentMethods`,
      cacheKey: CacheKeys.PaymentMethods(context.session.accountId),
      callback: this.getPaymentMethodsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getPaymentMethodsCallback = (response) => {
    this.setState({errorList: response.errorList, paymentMethodList : response.paymentMethodList})
  }

  getStripeApiKey(context) {
    let cacheManager = new CacheManager({
      resource: '/api/stripe/key',
      cacheKey: CacheKeys.StripeApiKey(),
      callback: this.getStripeApiKeyCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getStripeApiKeyCallback = (response) => {
    this.setState({stripeApiKey: response.publicKey})
  }

  onPaymentSettingsChange = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.PaymentMethods(context.session.accountId));
    this.getPaymentMethods(context)
  }

  getMessages(context) {
    let arr = [
      'c_credit_card',
      'c_card_number',
      'c_card_brand',
      'c_card_ending_with',
      'c_card_expiration',
      //
      'c_add_card',
      'c_update_card',
      'c_remove_card',
      'c_no_card',
      //
      'c_cancel',
      'c_remove_card_confirm',
      'c_yes_remove',
      'c_do_not_remove'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_acc_cc', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default PaymentSettingsPageSF
